module.exports = (s) => {
  return [{
    name: 'ID',
    value: 'id',
    props: { width: 100 },
  },
  {
    name: '所属游戏',
    value: 'game.name',
    props: { width: 300 },
  },
  {
    name: '标签',
    value: 'label',
  },
  {
    name: '标签说明',
    value: 'remark',
    props: { width: 320, overflow: false },
    format: (row) => {
      const h = s.$createElement;
      const remark = row.remark || '-';
      if (!row.remark) {
        return remark;
      }
      return h('el-input', {
        class: 'material-label-remark-input',
        props: {
          type: 'textarea',
          value: remark,
          readonly: true,
          resize: 'none',
          autosize: { minRows: 1, maxRows: 3 },
        },
      });
    },
  },
  {
    name: '标签等级',
    value: 'level',
    format: (row) => ({ 1: '一级标签', 2: '二级标签' }[row.level] || ''),
  },
  {
    name: '操作',
    props: { width: 160 },
    format: (row) => {
      const h = s.$createElement;
      return h('div', null, [
        h('el-button', {
          props: {
            type: 'primary',
            size: 'mini',
            disabled: row.loading,
          },
          on: {
            click: () => s.openEditDialog(row),
          },
        }, '编辑'),
        h('el-button', {
          props: {
            type: 'danger',
            size: 'mini',
            loading: row.loading,
          },
          on: {
            click: () => s.onDeleteMaterialLabel(row),
          },
        }, '删除'),
      ]);
    },
  }];
};
